import { Trans } from "@lingui/react/macro";

import type { components } from "@/shared/api";

type GameMode = components["schemas"]["GameMode"];

// Подпись режима не обычного матча: «Street Brawl» или «другой режим».
export const GameModeLabel = ({ mode }: { mode: Exclude<GameMode, "normal"> }) =>
  mode === "street_brawl" ? <Trans>Street Brawl</Trans> : <Trans>other mode</Trans>;
